export const INTERACTION_COLORS = {
    AgentText: "#0a4387",
    "Agent Text": "#0a4387",
    BlindTransfer: "#00aec7",
    "Blind Transfer": "#00aec7",
    Cancel: "#333f48",
    ControlledTransfer: "#00aec7",
    "Controlled Transfer": "#00aec7",
    Disconnect: "#a2aaad",
    Email: "#666666",
    Error: "#d2001e",
    HandoffTransfer: "#00aec7",
    "Handoff Transfer": "#00aec7",
    Hangup: "#5b6770",
    HangUp: "#5b6770",
    VoiceMessage: "#00aec7",
    "Voice Message": "#00aec7",
};
export const normalizeInteractionFinalAction = (action) => {
    if (!action)
        return "Unknown";
    if (action === "Disconnected") {
        return "Disconnect";
    }
    if (action === "HangUp") {
        return "Hangup";
    }
    return action;
};
export const getInteractionColor = (actionName) => {
    const normalizedAction = actionName.toLowerCase().replace(/[\s-]/g, "");
    if (normalizedAction.startsWith("agenttext")) {
        return INTERACTION_COLORS.AgentText || "#0a4387";
    }
    if (normalizedAction.startsWith("voicemessage")) {
        return INTERACTION_COLORS.VoiceMessage || "#00aec7";
    }
    if (INTERACTION_COLORS[actionName]) {
        return INTERACTION_COLORS[actionName];
    }
    switch (normalizedAction) {
        case "blindtransfer":
            return INTERACTION_COLORS.BlindTransfer || "#00aec7";
        case "cancel":
            return INTERACTION_COLORS.Cancel || "#333f48";
        case "controlledtransfer":
            return INTERACTION_COLORS.ControlledTransfer || "#00aec7";
        case "disconnect":
        case "disconnected":
            return INTERACTION_COLORS.Disconnect || "#a2aaad";
        case "email":
            return INTERACTION_COLORS.Email || "#666666";
        case "error":
            return INTERACTION_COLORS.Error || "#d2001e";
        case "handofftransfer":
            return INTERACTION_COLORS.HandoffTransfer || "#00aec7";
        case "hangup":
            return INTERACTION_COLORS.Hangup || "#5b6770";
        default:
            return "#6b7280";
    }
};
//# sourceMappingURL=platformMetrics.js.map